// Persists the session's start timestamp across a hard refresh, the same way
// authStateEncrypted persists the auth token (see App.js's rehydration
// block) — Redux state alone doesn't survive a refresh. Stored in plain
// (unencrypted) localStorage since it's just a timestamp, not sensitive.
const SESSION_STARTED_AT_KEY = "sessionStartedAt";

export const persistSessionStartedAt = (timestamp) => {
  if (timestamp == null) {
    localStorage.removeItem(SESSION_STARTED_AT_KEY);
  } else {
    localStorage.setItem(SESSION_STARTED_AT_KEY, String(timestamp));
  }
};

export const readPersistedSessionStartedAt = () => {
  const raw = localStorage.getItem(SESSION_STARTED_AT_KEY);
  const parsed = raw == null ? NaN : Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};
